export const INVOICE_STATUS_PAID = "Paid";
